// extracted by mini-css-extract-plugin
export const card = "card-module--card--3fnRF";
export const image = "card-module--image--304zT";
export const content = "card-module--content--OgfRO";